import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class SortformsService {

  constructor(
    private _http: HttpClient
  ) { }

  getAllTemplates(organizationId) {
    return this._http.get(environment.url + "/getAllTemplates/" + organizationId);
  }

  setPasswordToTemplate(data) {
    return this._http.put(environment.url + "/template/password", data);
  }

  archiveTemplate(requestData) {
    return this._http.put(environment.url + "/template/archive", requestData);
  }

  deleteTemplate(requestData) {
    return this._http.put(environment.url + "/template/delete", requestData);
  }

  activateTemplate(requestData) {
    return this._http.put(environment.url + "/template/activate", requestData, { headers: { "hideLoader": "true" } });
  }

  deactivateTemplate(requestData) {
    return this._http.put(environment.url + "/template/deactivate", requestData, { headers: { "hideLoader": "true" } });
  }

  getArchivedTemplates(organizationId) {
    return this._http.get(environment.url + "/template/archived/" + organizationId);
  }

  getDeletedTemplates(organizationId) {
    return this._http.get(environment.url + "/template/deleted/" + organizationId);
  }

  restoreArchivedTemplate(requestData) {
    return this._http.put(environment.url + "/template/archived/restore", requestData);
  }

  restoreDeletedTemplate(requestData) {
    return this._http.put(environment.url + "/template/deleted/restore", requestData);
  }

  generateSharedLink(requestData) {
    return this._http.post(environment.url + "/template/share/generate", requestData, { headers: { "hideLoader": "true" } });
  }

  disableSharedLink(requestData) {
    return this._http.post(environment.url + "/template/share/disable", requestData, { headers: { "hideLoader": "true" } });
  }
}
